export enum SideNavStatusEnum {
  collapse = "COLLAPSE",
  expanded = "EXPANDED",
  mouseenter = "MOUSEENTER",
  mouseleave = "MOUSELEAVE",
}
